__turbopack_context__.v({
  "compareWrapper": "FeatureSection-module__Kzaqga__compareWrapper",
  "featureSectionHeader": "FeatureSection-module__Kzaqga__featureSectionHeader",
  "infoIconContainer": "FeatureSection-module__Kzaqga__infoIconContainer",
  "infoSection": "FeatureSection-module__Kzaqga__infoSection",
  "loadingIndicator": "FeatureSection-module__Kzaqga__loadingIndicator",
  "planHelperCopy": "FeatureSection-module__Kzaqga__planHelperCopy",
  "planTitle": "FeatureSection-module__Kzaqga__planTitle",
});
